// extracted by mini-css-extract-plugin
export default {"Fieldset":"fieldset_Fieldset_qxEvd","InvisibleLegend":"fieldset_InvisibleLegend_roakk"};